import { css } from 'styled-components';

const metronetStyles = () => css`
  @font-face {
    font-family: 'Titillium Web';
    font-style: normal;
    font-weight: 300;
    src: url(${`/fonts/Titillium/titillium-web-v8-latin-300.eot`}); /* IE9 Compat Modes */
    src:
      local('Titillium Web Light'),
      local('TitilliumWeb-Light'),
      url(${`/fonts/Titillium/titillium-web-v8-latin-300.eot?#iefix`}) format('embedded-opentype'),
      /* IE6-IE8 */ url(${`/fonts/Titillium/titillium-web-v8-latin-300.woff2`}) format('woff2'),
      /* Super Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-300.woff`})
        format('woff'),
      /* Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-300.ttf`})
        format('truetype'),
      /* Safari, Android, iOS */
        url(${`/fonts/Titillium/titillium-web-v8-latin-300.svg#TitilliumWeb`}) format('svg'); /* Legacy iOS */
  }
  /* titillium-web-300italic - latin */
  @font-face {
    font-family: 'Titillium Web';
    font-style: italic;
    font-weight: 300;
    src: url(${`/fonts/Titillium/titillium-web-v8-latin-300italic.eot`}); /* IE9 Compat Modes */
    src:
      local('Titillium Web Light Italic'),
      local('TitilliumWeb-LightItalic'),
      url(${`/fonts/Titillium/titillium-web-v8-latin-300italic.eot?#iefix`})
        format('embedded-opentype'),
      /* IE6-IE8 */ url(${`/fonts/Titillium/titillium-web-v8-latin-300italic.woff2`})
        format('woff2'),
      /* Super Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-300italic.woff`})
        format('woff'),
      /* Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-300italic.ttf`})
        format('truetype'),
      /* Safari, Android, iOS */
        url(${`/fonts/Titillium/titillium-web-v8-latin-300italic.svg#TitilliumWeb`}) format('svg'); /* Legacy iOS */
  }
  /* titillium-web-italic - latin */
  @font-face {
    font-family: 'Titillium Web';
    font-style: italic;
    font-weight: 400;
    src: url(${`/fonts/Titillium/titillium-web-v8-latin-italic.eot`}); /* IE9 Compat Modes */
    src:
      local('Titillium Web Italic'),
      local('TitilliumWeb-Italic'),
      url(${`/fonts/Titillium/titillium-web-v8-latin-italic.eot?#iefix`})
        format('embedded-opentype'),
      /* IE6-IE8 */ url(${`/fonts/Titillium/titillium-web-v8-latin-italic.woff2`}) format('woff2'),
      /* Super Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-italic.woff`})
        format('woff'),
      /* Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-italic.ttf`})
        format('truetype'),
      /* Safari, Android, iOS */
        url(${`/fonts/Titillium/titillium-web-v8-latin-italic.svg#TitilliumWeb`}) format('svg'); /* Legacy iOS */
  }
  /* titillium-web-regular - latin */
  @font-face {
    font-family: 'Titillium Web';
    font-style: normal;
    font-weight: 400;
    src: url(${`/fonts/Titillium/titillium-web-v8-latin-regular.eot`}); /* IE9 Compat Modes */
    src:
      local('Titillium Web Regular'),
      local('TitilliumWeb-Regular'),
      url(${`/fonts/Titillium/titillium-web-v8-latin-regular.eot?#iefix`})
        format('embedded-opentype'),
      /* IE6-IE8 */ url(${`/fonts/Titillium/titillium-web-v8-latin-regular.woff2`}) format('woff2'),
      /* Super Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-regular.woff`})
        format('woff'),
      /* Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-regular.ttf`})
        format('truetype'),
      /* Safari, Android, iOS */
        url(${`/fonts/Titillium/titillium-web-v8-latin-regular.svg#TitilliumWeb`}) format('svg'); /* Legacy iOS */
  }
  /* titillium-web-600 - latin */
  @font-face {
    font-family: 'Titillium Web';
    font-style: normal;
    font-weight: 600;
    src: url(${`/fonts/Titillium/titillium-web-v8-latin-600.eot`}); /* IE9 Compat Modes */
    src:
      local('Titillium Web SemiBold'),
      local('TitilliumWeb-SemiBold'),
      url(${`/fonts/Titillium/titillium-web-v8-latin-600.eot?#iefix`}) format('embedded-opentype'),
      /* IE6-IE8 */ url(${`/fonts/Titillium/titillium-web-v8-latin-600.woff2`}) format('woff2'),
      /* Super Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-600.woff`})
        format('woff'),
      /* Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-600.ttf`})
        format('truetype'),
      /* Safari, Android, iOS */
        url(${`/fonts/Titillium/titillium-web-v8-latin-600.svg#TitilliumWeb`}) format('svg'); /* Legacy iOS */
  }
  /* titillium-web-600italic - latin */
  @font-face {
    font-family: 'Titillium Web';
    font-style: italic;
    font-weight: 600;
    src: url(${`/fonts/Titillium/titillium-web-v8-latin-600italic.eot`}); /* IE9 Compat Modes */
    src:
      local('Titillium Web SemiBold Italic'),
      local('TitilliumWeb-SemiBoldItalic'),
      url(${`/fonts/Titillium/titillium-web-v8-latin-600italic.eot?#iefix`})
        format('embedded-opentype'),
      /* IE6-IE8 */ url(${`/fonts/Titillium/titillium-web-v8-latin-600italic.woff2`})
        format('woff2'),
      /* Super Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-600italic.woff`})
        format('woff'),
      /* Modern Browsers */ url(${`/fonts/Titillium/titillium-web-v8-latin-600italic.ttf`})
        format('truetype'),
      /* Safari, Android, iOS */
        url(${`/fonts/Titillium/titillium-web-v8-latin-600italic.svg#TitilliumWeb`}) format('svg'); /* Legacy iOS */
  }
`;

export default metronetStyles;
